import { Injectable } from "@angular/core";
import { Observable, fromEvent } from "rxjs";
import { map, startWith, distinctUntilChanged } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class ResponsiveService {
  private mobileWidth = 768;
  private shortHeight = 700;

  isMobile$: Observable<boolean>;
  isShortScreen$: Observable<boolean>;

  constructor() {
    const resize$ = fromEvent(window, "resize").pipe(startWith({}));

    this.isMobile$ = resize$.pipe(
      map(() => window.innerWidth < this.mobileWidth),
      distinctUntilChanged()
    );

    this.isShortScreen$ = resize$.pipe(
      map(() => window.innerHeight <= this.shortHeight),
      distinctUntilChanged()
    );
  }
}
